const LogoFull = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="auto"
    height="36"
    viewBox="0 0 260 36"
    aria-label="MKS Console"
  >
    {/* Orange square */}
    <rect x="0" y="2" width="32" height="32" rx="4" fill="#ff7900" />
    <text
      x="16"
      y="23"
      textAnchor="middle"
      fill="#000000"
      fontFamily="Helvetica Neue, Helvetica, Arial, sans-serif"
      fontWeight="700"
      fontSize="14"
    >
      MKS
    </text>
    {/* Wordmark */}
    <text
      x="44"
      y="24"
      fill="#ffffff"
      fontFamily="Helvetica Neue, Helvetica, Arial, sans-serif"
      fontWeight="700"
      fontSize="18"
    >
      Console
    </text>
  </svg>
);

export default LogoFull;
